import { fetchVacancy } from "../../../Auth/saaedaApi";

/**
 * Fetch a vacancy through the Saaeda backend proxy.
 * (Signature kept compatible with older callers — `accessToken` arg is ignored.)
 */
export async function queryVacancy(id, _accessTokenIgnored, _optsIgnored) {
  const record = await fetchVacancy(id);
  if (!record) throw new Error("Not found");
  return record;
}

/** Expired if end date < today or stage != In-Progress */
export function isVacancyExpired(record) {
  const jobEnd = record.Job_End_Date__c ? new Date(record.Job_End_Date__c) : null;
  if (jobEnd) jobEnd.setHours(0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return (jobEnd && jobEnd < today) || record.Stage__c !== "In-Progress";
}
